import { render, staticRenderFns } from "./cardsItem.vue?vue&type=template&id=4bf47e03&scoped=true"
import script from "./cardsItem.vue?vue&type=script&lang=js"
export * from "./cardsItem.vue?vue&type=script&lang=js"
import style0 from "./cardsItem.vue?vue&type=style&index=0&id=4bf47e03&prod&lang=less&scoped=true"
import style1 from "./cardsItem.vue?vue&type=style&index=1&id=4bf47e03&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf47e03",
  null
  
)

export default component.exports